import React, { Component } from 'react'
import moment from 'moment'
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Icon,
  Input,
  InputNumber,
  Menu,
  Modal,
  Popconfirm,
  Row,
  Spin,
  Tooltip
} from 'antd'
import { formatDecimal } from 'src/core/utils/object'
import autobind from 'autobind-decorator'
import { withTranslation, WithTranslation } from 'react-i18next'
import { ProjectTaskSummary } from 'src/stores/projecttasks-store'
import ProjectTaskEditor from './timesheet-editprojecttask'
import TextArea from 'antd/lib/input/TextArea'
import { isNumber, isString } from 'util'
import EditableTooltip from 'src/components/editable-tooltip/tooltip'
import { ProjectSummary } from '../stores/projects-store'
import { TimesheetTaskItem } from 'src/pages/timesheet'
import { InputNumberProps } from 'antd/lib/input-number'
import './timesheet.less'
import 'src/core/assets/site.less'
import Favorite from './favorite'
import TimeSheetButton from './timeSheetButton'

const Search = Input.Search

export type TimesheetStatus = 'Draft' | 'Pending' | 'Approved' | 'Rejected'

interface TimesheetInputViewProps extends InputNumberProps, WithTranslation {
  onAddMessage: () => void
  message: string | undefined
  optionalTitle: string
  isEditableMessage: boolean
}

interface TimesheetInputViewState {
}

class TimesheetInputView extends Component<TimesheetInputViewProps, TimesheetInputViewState> {
  constructor(props: TimesheetInputViewProps) {
    super(props)
  }

  @autobind
  private onAddMessage() {
    if (this.props.onAddMessage)
      this.props.onAddMessage()
  }

  render() {
    const { t } = this.props

    const options = <Menu>
      <Menu.Item key={'std_menu'} onClick={this.onAddMessage}>{this.props.optionalTitle}</Menu.Item>
    </Menu>

    return (
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", backgroundColor: "white" }}>
        <div style={{ flexGrow: 100 }}>
          <InputNumber {...this.props as InputNumberProps} />
        </div>
        {this.props.message &&
          <div style={{ marginLeft: 3, marginRight: 1.5 }}>
            <Tooltip overlayStyle={{ whiteSpace: 'pre-line' }} title={this.props.message}>
              <Icon type='message' style={{ marginTop: 13 }} />
            </Tooltip>
          </div>}
        {this.props.isEditableMessage &&
          <div>
            <Dropdown overlay={options}>
              <Icon type='more' style={{ marginTop: 13 }} />
            </Dropdown>
          </div>}
      </div>
    )
  }
}

interface TimesheetProps extends WithTranslation {
  employeeId: string,
  comapnyId: string,
  timesheetId: string,
  isFutureAllowed: boolean
  start: Date,
  end: Date,
  readonly?: boolean,
  canManage?: boolean,
  minHours: number,
  maxHours: number,
  status: TimesheetStatus,
  statusMessage?: string,
  rowsDataSource: RowsDataSource,
  cellsDataSource: CellsDataSource,
  onAddProjectTask?: () => void,
  onDeleteEmptyTask?: () => void,
  onDeleteMultiple?: (items: string[]) => void,
  onSave?: (changes: TimesheetChange[]) => Promise<boolean>,
  onPublish?: () => Promise<boolean>,
  onValidationHours?: any,
  onRecall?: () => Promise<boolean>,
  onApprove?: (message: string) => Promise<boolean>,
  onReject?: (message: string) => Promise<boolean>
  onRemoveProjectTask?: (projectTaskId: string) => Promise<void>
  onDownload?: (format?: string) => Promise<boolean>,
  isCompanyManager?: boolean,
  hasRoleAdminOrManager?: boolean
  filteredProjects?: string[]
  projectIdToSummary: Map<string, ProjectSummary>
  employeeMinHours?: number[]
  employeeMaxHours?: number[]
  showFavorite: boolean
  selectedTimesheetHasChanges?: (changed: boolean) => void
  employeeTitle?: any
  onLoad?: (loading: boolean) => void
  showBtnClone?: boolean
  isManager?: boolean
  companyHoursManager?: boolean
}

export interface TimesheetChange {
  rowKey: any,
  colKey: any,
  value: any,
  message?: string
  taskTitle: string,
  projectTitle: string,

}

interface TimesheetState {
  pivotData: any,
  pivotDataMessages: any,
  changes: TimesheetChange[],
  searchQuery: string | undefined,
  tasks: ProjectTaskSummary[],
  isBusy: boolean,
  rowEditing: any,
  showConfirmModal: boolean,
  ConfirmModalSelected: 'Approve' | 'Reject' | undefined,
  statusMessageText: string,
  selectedItems: string[],
  remInPercent: boolean,
  changeHistory: CellData[],
  isAddingLogMessage: boolean,
  currentLogMessageCol: any,
  currentLogMessageRow: any,
  currentLogMessage: string | undefined,
  expandedProjects: Set<string>,
  lockedExpandedProjects: Set<string>,
  taskIdsToProjectIds: Map<string, string>,
  errorMessage: string,
  showError: boolean,
  openModalConfirm: boolean,
  isCheckboxChecked: boolean,
  previousStart: Date | undefined
}

interface DayHeader {
  date: moment.Moment,
  dayName: string,
  dayNumber: number,
  dayNumberStr: string,
  weekend: boolean
}

interface MonthHeader {
  monthName: string,
  monthNumber: number,
  year: number,
  days: DayHeader[]
}

interface RowData {
  rowKey: any,
  object: any,
  projectTitle: string,
  projectTaskTitle: string,
  projectId: string,
  isFavorite: boolean,
  disabled: boolean
}

interface RowsDataSource {
  items: RowData[],
  title: string,
  onSearch: (item: RowData, q: string) => boolean,
  render: (item: RowData) => React.ComponentElement<any, any>
}

interface CellData {
  rowKey: any,
  referenceKey: any, //User for projectId
  colKey: any,
  value: any,
  optionalValue?: any,
  object: any,
}

interface CellsDataSource {
  items: CellData[],
  defaultValue: any,
}

export function StatusView(props: any): React.ReactElement<any> {
  var t = props.t || ((s: string) => s)
  switch (props.status as TimesheetStatus) {
    case 'Draft':
      return <Tooltip title={t('Draft')}><span className='timesheet-draft' style={props.style}><Icon
        type="exclamation-circle" /> {!props.iconOnly && t('Draft')}</span></Tooltip>
    case 'Pending':
      return <Tooltip title={t('Pending')}><span className='' style={props.style}><Icon
        type="clock-circle" /> {!props.iconOnly && t('Pending')}</span></Tooltip>
    case 'Approved':
      return <Tooltip title={t('Approved')}><span className='timesheet-success' style={props.style}><Icon
        type="check-circle" /> {!props.iconOnly && t('Approved')}</span></Tooltip>
    case 'Rejected':
      return <Tooltip title={t('Rejected')}><span className='timesheet-rejected' style={props.style}><Icon
        type="close-circle" /> {!props.iconOnly && t('Rejected')}</span></Tooltip>
    default:
      return <span>t("Unknown")</span>
  }
}

export function GetProjectTaskNames(projectTask: TimesheetTaskItem) {
  var projectName = projectTask.projectTitle
  var taskName = projectTask.projectTaskTitle
  if (!(projectName && taskName)) {
    var split = projectTask.title.split("-")
    projectName = split[0]
    taskName = (taskName) ? taskName : split.slice(1).join()
  }
  return [projectName.trimEnd().trimStart(), taskName.trimEnd().trimStart()]
}

function deleteChangeFromList(changes: TimesheetChange[], change: TimesheetChange) {
  const index: number = changes.indexOf(change)
  if (index !== -1) {
    changes.splice(index, 1)
  }
}

class Timesheet extends Component<TimesheetProps, TimesheetState> {
  validDays: boolean[]
  lockKey: string = "||-|-||"
  changeLogs: Map<string, TimesheetChange[]>
  totalProjectHoursPerDay: Map<string, Map<number, number>>
  totalProjectHours: Map<string, number>

  constructor(props: TimesheetProps) {
    super(props)
    var lockedExpandedProjects = new Set(window.localStorage.getItem(`${this.props.employeeId} - ${this.props.timesheetId}`)?.split(this.lockKey))
    this.state = {
      changes: [],
      pivotData: [],
      pivotDataMessages: [],
      searchQuery: undefined,
      isBusy: false,
      tasks: [],
      rowEditing: undefined,
      showConfirmModal: false,
      ConfirmModalSelected: undefined,
      statusMessageText: '',
      selectedItems: [],
      remInPercent: true,
      changeHistory: [],
      isAddingLogMessage: false,
      currentLogMessage: undefined,
      currentLogMessageCol: 0,
      currentLogMessageRow: 0,
      expandedProjects: lockedExpandedProjects ? lockedExpandedProjects : new Set(),
      lockedExpandedProjects: lockedExpandedProjects ? lockedExpandedProjects : new Set(),
      taskIdsToProjectIds: new Map(),
      errorMessage: "",
      showError: false,
      openModalConfirm: false,
      isCheckboxChecked: true,
      previousStart: undefined
    }
    this.totalProjectHoursPerDay = new Map(),
      this.totalProjectHours = new Map()
    this.validDays = [true, true, true, true, true]
    this.changeLogs = new Map()
  }

  componentDidUpdate(prev: TimesheetProps) {
    var lockedExpandedProjects = new Set(window.localStorage.getItem(`${this.props.employeeId} - ${this.props.timesheetId}`)?.split(this.lockKey))
    if (prev.timesheetId != this.props.timesheetId) {
      this.setState({
        selectedItems: [],
        changes: [],
        changeHistory: [],
        lockedExpandedProjects: lockedExpandedProjects
      }, () => this.props.selectedTimesheetHasChanges && this.props.selectedTimesheetHasChanges(false))
      this.validDays = [true, true, true, true, true]
      this.retractAllProjects()
    }
  }

  static getDerivedStateFromProps(props: TimesheetProps, state: TimesheetState): TimesheetState {
    let pivotData: any = []
    let pivotDataMessages: any = []
    let changes = state.changes
    let removedTasksWithChanges = new Set<string>(changes.map(change => change.rowKey)) //used to pinpoint changes with no asociated task

    let tasksIdsToProjects: Map<string, string> = new Map()

    props.cellsDataSource.items.forEach(cell => {
      if (!pivotData[cell.rowKey]) {
        pivotData[cell.rowKey] = []
        pivotDataMessages[cell.rowKey] = []
      }
      pivotData[cell.rowKey][cell.colKey] = cell.value
      pivotDataMessages[cell.rowKey][cell.colKey] = cell.optionalValue
    })

    props.rowsDataSource.items.forEach(task => {
      removedTasksWithChanges.delete(task.rowKey)
      tasksIdsToProjects.set(task.rowKey, task.projectId) //Set taskid to ProjectId
    })

    return {
      ...state,
      pivotData: pivotData,
      pivotDataMessages: pivotDataMessages,
      taskIdsToProjectIds: tasksIdsToProjects,
      changes: changes.filter(c => !removedTasksWithChanges.has(c.rowKey))
    }
  }

  static getMonths(start: Date, end: Date) {
    var startDate = moment.utc(start).startOf('day')
    var endDate = moment.utc(end).startOf('day')
    var months: MonthHeader[] = []
    var currentMonth: MonthHeader | undefined = undefined
    var day = startDate
    while (day <= endDate) {
      var currentMonthName = day.format('MMMM')
      if (currentMonth == undefined || currentMonth!.monthName != currentMonthName) {
        months.push(currentMonth = {
          monthNumber: day.month(),
          monthName: currentMonthName,
          days: [],
          year: day.year()
        })
      }
      currentMonth.days.push({
        date: day,
        dayName: day.format("dd"),
        dayNumberStr: day.format("DD"),
        dayNumber: day.date(),
        weekend: day.isoWeekday() > 5
      })
      day = day.add(1, 'day')
    }
    return months
  }

  @autobind
  private compareDatesWithFirstMonday(start: Date, end: Date): boolean {
    let startDate = moment(start).subtract(1, 'day').startOf('day')
    const currentDate = moment().startOf('day')
    const previousStart = this.state.previousStart ? moment(this.state.previousStart).startOf('day') : null

    if (!previousStart || previousStart.isBefore(startDate)) {
      this.setState({ previousStart: startDate.toDate() })

      return false
    }

    const numMondays = Math.ceil(currentDate.diff(previousStart, 'weeks', true))

    if (numMondays > 1) {
      return false
    }

    return true
  }

  @autobind
  private handleFocus(event: any) {
    event.target.select()
    event.target.addEventListener("wheel", function (event: { preventDefault: () => void }) { event.preventDefault() }, { passive: false })
  }

  @autobind
  private onAddMessage(rowKey: any, colKey: any) {
    this.setState({
      isAddingLogMessage: true,
      currentLogMessageCol: colKey,
      currentLogMessageRow: rowKey
    })
  }

  @autobind
  private expandAllProjects() {
    var projects = Array.from(this.state.taskIdsToProjectIds.values())
    this.setState({ expandedProjects: new Set(projects) })
  }

  @autobind
  private retractAllProjects() {
    this.setState({ expandedProjects: new Set(this.state.lockedExpandedProjects.toArray()) })
  }

  @autobind
  private onSelectLockExpanded(expand: boolean, projectId: string) {
    this.setState({ isBusy: true })
    let lockedExpandedProjects = new Set(this.state.lockedExpandedProjects)
    let expandedProjects = new Set(this.state.expandedProjects)

    if (expand) {
      lockedExpandedProjects.add(projectId)
      expandedProjects.add(projectId)
    } else {
      lockedExpandedProjects.delete(projectId)
    }

    window.localStorage.setItem(`${this.props.employeeId} - ${this.props.timesheetId}`, lockedExpandedProjects.toArray().join(this.lockKey))
    this.setState({
      isBusy: false,
      expandedProjects: expandedProjects,
      lockedExpandedProjects: lockedExpandedProjects
    })
  }

  @autobind
  private onSelectedProjectRow(r: RowData, index: number) {
    if (this.state.lockedExpandedProjects.has(r.projectId)) {
      return
    }

    var expandedProjects = new Set(this.state.expandedProjects)
    if (expandedProjects.has(r.projectId)) {
      expandedProjects.delete(r.projectId)
    } else {
      expandedProjects.add(r.projectId)
    }
    this.setState({ expandedProjects: expandedProjects })
  }

  @autobind
  private async handleChange(rowKey: any, colKey: any, value: any, message: string, taskTitle: string, projectTitle: string, index: number) {
    this.setState({ showError: false })
    if (this.props.status != 'Draft') return
    const { t } = this.props

    var changes = [...this.state.changes]
    value = isNumber(value) ? value : 0
    message = isString(message) ? message.trim() : ""

    if (this.props.employeeMinHours && this.props.employeeMaxHours && this.props.employeeMinHours[index] == this.props.employeeMaxHours[index] && this.props.employeeMinHours[index] == 0 && value != 0) {
      var errorMessage = t("This is a forbidden day to input hours")
      this.setState({ errorMessage: errorMessage, showError: true })
      return
    }
    var cleanedChanges = this.getCleanedChanges().filter(c => c.rowKey != rowKey && c.colKey == colKey)
    var count = this.sumAllHoursPerDay(colKey, cleanedChanges, rowKey)
    count += value

    if (this.props.employeeMaxHours && count > this.props.employeeMaxHours[index] && value != 0) {

      var errorMessage = t("max_hours_per_day_exceeded", { employeeMaxHours: this.props.employeeMaxHours[index] })
      this.setState({ errorMessage: errorMessage, showError: true })
      return
    }

    //if value is invalid
    if (value > 24) return

    //if value is not original
    let isNonOriginalValue = value != (this.state.pivotData[rowKey] ? this.state.pivotData[rowKey][colKey] || this.props.cellsDataSource.defaultValue : this.props.cellsDataSource.defaultValue)
    let isNonOriginalMessage = message != (this.state.pivotData[rowKey] ? this.state.pivotDataMessages[rowKey][colKey] ?? "" : "")

    // look for the latest change for the cell
    var item = this.getCleanedChanges().firstOrDefault(c => c.rowKey == rowKey && c.colKey == colKey)
    if (item !== null) {
      if (value == item.value && message == item.message)
        return //if current change is the same then do not record
    }

    if (isNonOriginalValue || isNonOriginalMessage) {
      // if non original value and message then add change at
      // the last position of the queue

      let newChange = {
        rowKey: rowKey,
        colKey: colKey,
        value: value,
        taskTitle: taskTitle,
        projectTitle: projectTitle,
        message: message,
      }
      changes.push(newChange)
    } else {
      // if original value and message then erase all ocurrences
      // of changes applying to this cell

      changes = changes.filter((change) => change.rowKey != rowKey || change.colKey != colKey)
    }
    this.setState({
      changes: changes,
      isAddingLogMessage: false
    }, () => this.props.selectedTimesheetHasChanges && this.props.selectedTimesheetHasChanges(this.state.changes.length > 0))
  }

  @autobind
  private async onSave() {
    if (!this.props.onSave)
      return

    this.setState({ isBusy: true })
    try {
      var result = await this.props.onSave(this.getCleanedChanges())
      if (result)
        this.setState({
          changes: [],
          changeHistory: []
        }, () => this.props.selectedTimesheetHasChanges && this.props.selectedTimesheetHasChanges(false))
    } finally {
      this.setState({ isBusy: false })
    }
  }

  @autobind
  private async onPublish() {
    if (this.props.onPublish)
      await this.props.onPublish()
  }

  private async onValidationHours() {
    const result = await this.props.onValidationHours()
    return result
  }

  @autobind
  private async onRecall() {
    if (this.props.onRecall)
      await this.props.onRecall()
  }

  @autobind
  private async onApprove() {
    if (this.props.onApprove) {
      this.setState({ isBusy: true })
      this.props.onApprove(this.state.statusMessageText).then(result => {
        this.setState({ showConfirmModal: false, isBusy: false })
      }).catch(reason => {
        this.setState({ showConfirmModal: false, isBusy: false })
      })
    }
  }

  @autobind
  private async onReject() {
    if (this.props.onReject)
      await this.props.onReject(this.state.statusMessageText)
    this.setState({ showConfirmModal: false })
  }

  @autobind
  private async onRemoveRow(rowKey: string) {
    if (this.props.onRemoveProjectTask) {
      this.props.onRemoveProjectTask(rowKey)

      //remove all changes related to task
      let changes = [...this.state.changes]
      changes = changes.filter((change) => change.rowKey != rowKey)
      this.setState({ changes: changes }, () => this.props.selectedTimesheetHasChanges && this.props.selectedTimesheetHasChanges(this.state.changes.length > 0))
    }
  }

  @autobind
  private async onDownloadStandard() {
    if (this.props.onDownload)
      this.props.onDownload('standard')
  }

  @autobind
  private async onDownloadSpecial() {
    if (this.props.onDownload)
      this.props.onDownload('special')
  }

  @autobind
  private toggleSelection(itemId: string) {
    const index = this.state.selectedItems.findIndex(item => item === itemId)
    const currentState = this.state.selectedItems.slice()
    if (index >= 0) {
      currentState.splice(index, 1)
    } else {
      currentState.push(itemId)
    }
    this.setState({ selectedItems: currentState })
  }

  private filterByProjects(sheet: RowData) {
    let filter = this.props.filteredProjects == undefined ? [] : this.props.filteredProjects
    if (filter.length == 0) return false
    for (let i = 0; i < filter.length; i++) {
      if (sheet.object.projectTitle == filter[i]) {
        return false
      }
    }
    return true
  }

  private formatInput(value: number | string | undefined): string {
    if (value) {
      return value.toString()
    } else
      return "0.00"
  }

  @autobind
  private async GoBackHistory() {
    this.setState({ isBusy: true })
    let changes = [...this.state.changes]
    changes.pop()
    this.setState({
      isBusy: false,
      changes: changes
    }, () => this.props.selectedTimesheetHasChanges && this.props.selectedTimesheetHasChanges(this.state.changes.length > 0))
  }

  @autobind
  private cloneAndOrderChanges(): TimesheetChange[] {
    let changes = [...this.state.changes]
    changes.reverse()
    return changes
  }

  @autobind
  private getCleanedChanges(): TimesheetChange[] {
    let changes = this.cloneAndOrderChanges()
    changes = changes.distinct(change => `${change.rowKey}-${change.colKey}`).toArray()
    return changes
  }

  @autobind
  private getCurrentChange(row: any, col: number) {
    let changes = this.cloneAndOrderChanges()
    return changes ? changes.firstOrDefault(x => x.rowKey == row && x.colKey == col) : undefined
  }

  @autobind
  private getCurrentCellValue(row: any, col: number) {
    let currentCell = this.getCurrentChange(row, col)
    let currentValue = currentCell ? currentCell.value : !this.state.pivotData[row] ? 0 : (this.state.pivotData[row][col] || 0)
    return currentValue || currentCell ? currentValue : !this.state.pivotData[row] ? 0 : (this.state.pivotData[row][col] || 0)
  }

  @autobind
  private getCurrentCellMessage(row: any, col: number) {
    let currentCell = this.getCurrentChange(row, col)
    let currentMessage = currentCell ? currentCell.message : (!this.state.pivotDataMessages[row] ? "" : (this.state.pivotDataMessages[row][col] || ""))
    return currentMessage || ""
  }

  @autobind
  private sumAllHoursPerDay(col: number, changes: TimesheetChange[], rowKey?: number) {
    var count = 0
    for (var row in this.state.pivotData) {
      if (this.state.pivotData.hasOwnProperty(row)) {
        if (this.state.pivotData[row]) {
          this.state.pivotData[row].forEach((cellValue: any, idx: any) => {
            if (idx == col) {
              var changed = changes.firstOrDefault(c => c.rowKey == row && c.colKey == idx)
              if (!changed && (!rowKey || row != rowKey.toString()))
                count += cellValue
            }
          })
        }
      }
    }
    ;
    changes.filter(c => c.colKey == col).forEach(change => {
      count += change.value
    })

    count = Math.round(count * 100) / 100
    return count
  }

  private taskComparer(t1: TimesheetTaskItem, t2: TimesheetTaskItem) {
    if ((t1.isFavorite && t2.isFavorite) || (!t1.isFavorite && !t2.isFavorite)) {
      var n1 = t1.title.toUpperCase()
      var n2 = t2.title.toUpperCase()
      return (n1 > n2) ? 1 : ((n1 < n2) ? -1 : 0)
    }
    return t1.isFavorite ? -1 : 1
  }

  render() {
    const { t, employeeId, comapnyId, showFavorite } = this.props
    const canManage = this.props.canManage || false
    const isManage = this.props.isManager || false
    const isSameWeekAsFirstMonday = this.compareDatesWithFirstMonday(this.props.start, this.props.end)
    var readonly = this.props.readonly || this.props.status != 'Draft' || false
    var months: MonthHeader[] = Timesheet.getMonths(this.props.start, this.props.end)
    var self = this
    let changes = this.getCleanedChanges()

    var countHours = (row: any) => {
      var count = 0
      if (self.state.pivotData[row]) {
        self.state.pivotData[row].forEach((cellValue: any, idx: any) => {
          var changed = changes.firstOrDefault(c => c.rowKey == row && c.colKey == idx)
          if (!changed)
            count += cellValue
        })
      }
      changes.filter(c => c.rowKey == row).forEach(change => {
        count += change.value
      })
      return count
    }
    let dayCounter: number = 0
    var countDailyHours = (col: any, index: number) => {
      var count = this.sumAllHoursPerDay(col, changes)
      if (dayCounter < 5 && this.props.status != 'Approved' && this.props.status != 'Rejected') {
        let minHours = this.props.employeeMinHours ? this.props.employeeMinHours[dayCounter] : 0
        dayCounter += 1
        dayCounter %= 7

        let rem = Math.max(0, minHours - count)
        let isValidDay = true
        if (this.props.employeeMaxHours
          && this.props.employeeMinHours
          && index < this.props.employeeMaxHours.length) {
          isValidDay = (count <= this.props.employeeMaxHours[index])
        }

        this.validDays[index] = isValidDay
        let iconType = (!isValidDay) ? 'close-circle' : (rem > 0) ? "exclamation-circle" : "check-circle"
        let errorMessage = this.props.employeeMaxHours ? (t("Hours must be between ") + minHours + t(" and ") + this.props.employeeMaxHours[index]) : t("Hours must be greater than ") + minHours
        let tooltipTitle = (!isValidDay) ? errorMessage : formatDecimal(rem) + ' ' + t('remains')
        let className = (!isValidDay) ? 'timesheet-rejected' : (rem > 0) ? "timesheet-draft" : "timesheet-success"

        return (
          <div className="timesheet-hours-header">
            {String(count) + t(' ') + t('hrs')}
            <Tooltip
              title={tooltipTitle}
              defaultVisible={false}>
              <span style={{ marginLeft: '5px' }} className={className}>
                <Icon type={iconType} />
              </span>
            </Tooltip>
          </div>
        )
      } else return String(count) + t(' ') + t('hrs')
    }

    var countAllHours = () => {
      var count = 0

      this.totalProjectHoursPerDay = new Map()
      this.totalProjectHours = new Map()

      for (var row in self.state.pivotData) {
        if (self.state.pivotData.hasOwnProperty(row)) {
          if (self.state.pivotData[row]) {
            self.state.pivotData[row].forEach((cellValue: any, idx: any) => {
              var changed = changes.firstOrDefault(c => c.rowKey == row && c.colKey == idx)
              if (!changed)
                count += isNumber(cellValue) ? cellValue : 0

              //Set totals for projects
              let projectId = this.state.taskIdsToProjectIds.get(row)!
              var projectHours = this.totalProjectHoursPerDay.get(projectId)
              var totalHours = this.totalProjectHours.get(projectId) ?? 0

              if (projectHours === undefined) {
                projectHours = new Map<number, number>()
              }
              let current = projectHours.get(idx) ?? 0
              let hours = isNumber(cellValue) ? cellValue : 0
              totalHours += hours
              projectHours.set(idx, hours + current)
              this.totalProjectHoursPerDay.set(projectId, projectHours)
              this.totalProjectHours.set(projectId, totalHours)
            })
          }
        }
      }

      changes.forEach(change => {
        count += change.value

        //Set totals for projects
        let projectId = this.state.taskIdsToProjectIds.get(change.rowKey)!
        var projectHours = this.totalProjectHoursPerDay.get(projectId)
        var totalHours = this.totalProjectHours.get(projectId) ?? 0

        if (projectHours === undefined) {
          projectHours = new Map<number, number>()
        }
        let current = projectHours.get(change.colKey) ?? 0
        let hours = isNumber(change.value) ? change.value : 0
        totalHours += hours
        projectHours.set(change.colKey, hours + current)
        this.totalProjectHoursPerDay.set(projectId, projectHours)
        this.totalProjectHours.set(projectId, totalHours)
      })

      return count
    }

    let totalHours = countAllHours()

    var items = this.props.rowsDataSource.items
      .filter(r => !this.state.searchQuery || this.props.rowsDataSource.onSearch(r, this.state.searchQuery)).sort((a, b) => a.isFavorite && !b.isFavorite ? -1000 : (!a.isFavorite && b.isFavorite ? 1000 : a.projectTitle.localeCompare(b.projectTitle)))

    var newProject = Array(items.length).fill(true)
    if (items.length > 1)
      newProject = [true, ...Array(items.length - 1).fill(true).map((_, i) => (items[i].projectTitle !== items[i + 1].projectTitle) ? true : false)]

    const downloadOptions = <Menu>
      <Menu.Item key={'std_menu'} onClick={this.onDownloadStandard}>{t('Standard Format')}</Menu.Item>
      <Menu.Item key={'mtx_menu'} onClick={this.onDownloadSpecial}>{t('Matrix Format')}</Menu.Item>
    </Menu>

    const handleConfirm = async () => {
      this.setState({ openModalConfirm: false })
      const validationSuccess = await this.onValidationHours()
      if (validationSuccess == true) {
        if (this.state.isCheckboxChecked) {
          if (this.props.onDeleteEmptyTask) {
            this.setState({ openModalConfirm: false })
            await this.props.onDeleteEmptyTask()
          }
        } else {
          this.setState({ openModalConfirm: false })
          this.onPublish()
        }
        this.onPublish()

      } else {
        this.setState({ openModalConfirm: false })
      }
    }

    const handleload = (isBusy: boolean) => {
      if (typeof this.props.onLoad === 'function') {
        this.props.onLoad(isBusy)
      }
    }

    return (
      <Spin size='large' spinning={this.state.isBusy}>
        {this.state.showError && <Alert type='error' message={this.state.errorMessage} />}
        <Card style={{ padding: 20 }} className="ibox">
          <div
            className='timesheet ant-table ant-table-default ant-table-bordered ant-table-scroll-position-left'>
            <div className='ant-table-content'>
              <div className='ant-table-body'>
                <div className='headerTimesheet'
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                  <ul className='toolbar' style={{ paddingLeft: 0, marginBottom: 5 }}>
                    {this.props.statusMessage && <li style={{ marginLeft: 10 }}><small
                      style={{ textTransform: 'uppercase' }}>{t('Reason')}</small><span
                        className='timesheet-rejected'
                        style={{ display: 'block' }}>{this.props.statusMessage}</span></li>}

                    <li style={{ marginLeft: 10, float: 'right' }}>
                      <EditableTooltip name='timesheet-remaining-hours' noIcon>
                        <small style={{ textTransform: 'uppercase' }}> {t('Hours')}
                          <Icon
                            type="info-circle" style={{
                              fontSize: '12px',
                              color: 'grey',
                              marginRight: 3,
                              marginLeft: 3
                            }} />
                        </small>
                        <span style={{ display: 'block' }}> {formatDecimal(totalHours)} {t('hrs')}
                          {this.props.minHours > 0 && this.props.minHours > totalHours ?
                            <span> ({formatDecimal(this.props.minHours - totalHours)} {t('remains')}) </span> : undefined}
                        </span>
                      </EditableTooltip>
                    </li>
                    <li style={{ marginLeft: 10, float: 'right' }}>
                      <EditableTooltip name='timesheet-status' noIcon>
                        <small style={{ textTransform: 'uppercase' }}> {t('Status')} </small>
                        <Icon type="info-circle" style={{
                          fontSize: '12px',
                          color: 'grey',
                          marginRight: 3,
                          marginLeft: 3
                        }} />
                        <span>
                          <StatusView style={{ textTransform: 'uppercase', display: 'block' }}
                            t={t} status={this.props.status} />
                        </span>
                      </EditableTooltip>
                    </li>
                    <li style={{ marginLeft: 10, float: 'right' }}>
                      <h1 style={{ color: 'blue', fontSize: '20px' }}>
                        {this.props.employeeTitle}
                      </h1>
                    </li>
                  </ul>
                  <ul className='toolbar' style={{ marginBottom: 5 }}
                    data-tut="reactour__saveTimesheet">
                    {this.state.changes.length > 0 &&
                      <li>
                        <Button
                          onClick={this.GoBackHistory}
                          disabled={this.state.changes.length == 0}
                          type='danger'
                          icon={'undo-fill'}
                        >{t('Undo')}
                        </Button>
                      </li>}
                    <li>
                      <TimeSheetButton onLoad={handleload} companyId={comapnyId}
                        employeeId={employeeId}
                        isSameWeekAsFirstMonday={isSameWeekAsFirstMonday}
                        showBtnClone={this.props.showBtnClone!}
                        timesheetId={this.props.timesheetId} />
                    </li>
                    {this.props.onDownload &&
                      <li><EditableTooltip name='timesheet-download' noIcon>
                        <Dropdown.Button
                          overlay={downloadOptions}>{t('Download')}
                          <Icon type="info-circle"
                            style={{
                              fontSize: '12px',
                              color: 'grey',
                              marginRight: 3,
                              marginLeft: 3
                            }}
                          />
                        </Dropdown.Button>
                      </EditableTooltip>
                      </li>}
                    {(((!readonly || this.props.isCompanyManager) && this.props.onSave) || (this.props.status === 'Draft' && this.props.companyHoursManager && isManage)) &&
                      <li><Button disabled={this.state.changes.length == 0} type='primary'
                        onClick={this.onSave}>{t('Save')}</Button></li>}
                    {!readonly && this.props.onPublish &&
                      <li>
                        <Modal
                          title={t('Confirmation required')}
                          visible={this.state.openModalConfirm}
                          onOk={handleConfirm}
                          onCancel={() => this.setState({ openModalConfirm: false })}
                          okText={t('Yes')}
                          cancelText={t('No')}
                          okButtonProps={{ loading: this.state.isBusy }}
                        >
                          <span> {t('Are you sure you want to publish the timesheet?')}</span>
                          <Form.Item>
                            <Checkbox
                              checked={this.state.isCheckboxChecked}
                              onChange={(e) => this.setState({ isCheckboxChecked: e.target.checked })}
                            >
                              <span>{t('Remove the empty lines before publishing your time sheet')}</span><Icon
                                type="info-circle" style={{
                                  fontSize: '12px',
                                  color: 'grey',
                                  marginRight: 3,
                                  marginLeft: 3
                                }} /></Checkbox>
                          </Form.Item>
                        </Modal>
                        <EditableTooltip name='timesheet-publish' noIcon>
                          <Button
                            disabled={this.state.changes.length > 0}
                            type='default'
                            onClick={() => this.setState({ openModalConfirm: true })}
                          >{t('Publish')} <Icon type="info-circle" style={{
                            fontSize: '12px',
                            color: 'grey',
                            marginRight: 3,
                            marginLeft: 3
                          }} />
                          </Button>
                        </EditableTooltip>
                      </li>
                    }
                    {((this.props.status == 'Rejected' || this.props.status == 'Pending') && !canManage) || (canManage && (this.props.status == 'Rejected' || this.props.status == 'Approved')) &&
                      <li>
                        <Button type='primary' onClick={this.onRecall}>{t('Recall')}</Button>
                      </li>}
                    {(this.props.status == 'Pending' && canManage) &&
                      <li><Button type='primary' onClick={() => this.setState({
                        showConfirmModal: true,
                        ConfirmModalSelected: "Approve"
                      })}>{t('Approve')}</Button></li>}
                    {(this.props.status == 'Pending' && canManage) &&
                      <li><Button type='danger' onClick={() => this.setState({
                        showConfirmModal: true,
                        ConfirmModalSelected: "Reject"
                      })}>{t('Reject')}</Button></li>}
                  </ul>
                  <Modal
                    title={t('Confirmation Message')}
                    visible={this.state.showConfirmModal}
                    onOk={this.state.ConfirmModalSelected == 'Approve' ? this.onApprove : this.onReject}
                    onCancel={() => this.setState({ showConfirmModal: false, statusMessageText: '' })}
                    okText={t('Ok')}
                    cancelText={t('Cancel')}
                    okButtonProps={{ loading: this.state.isBusy }}>
                    <Row justify="center">
                      <Col>
                        {this.validDays.any(x => !x) &&
                          <p>
                            <Icon type="warning" style={{ color: "orangered" }} />
                            {" " + t("This timesheet presents invalid imputed hours, according to the employee's restriction plan.")}
                          </p>
                        }
                        <p>{t('Comment')}</p>
                        <TextArea
                          onChange={({ target: { value } }) => this.setState({ statusMessageText: value })}
                          value={this.state.statusMessageText}
                        />
                      </Col>
                    </Row>
                  </Modal>
                </div>
                <table>
                  <thead id="table-timesheet" className="ant-table-thead">
                    <tr>
                      <th rowSpan={2} style={{ position: "relative", width: 300 }}>
                        <div style={{ marginLeft: -7 }}>
                          <div className="timesheet-header" style={{
                            position: "absolute",
                            top: 16,
                            textAlign: "center",
                            width: "100%",
                            marginLeft: -20
                          }}>
                            {this.props.rowsDataSource.title}
                          </div>
                          <div style={{ position: "absolute", bottom: 8, width: 270 }}>
                            <Search value={this.state.searchQuery}
                              onChange={(e) => this.setState({ searchQuery: e.target.value })} />
                          </div>
                        </div>
                      </th>
                      {months.map(m => <th key={`${m.year}${m.monthName}`} colSpan={m.days.length}
                        className="timesheet-header">{m.monthName}, {m.year}</th>)}
                      <th rowSpan={3} className="timesheet-header">TOTAL</th>
                    </tr>
                    <tr>
                      {months.map(m => m.days.map(d => <th key={d.dayNumberStr}
                        className={d.weekend ? 'weekend timesheet-header' : "timesheet-header"}>{d.dayName} {d.dayNumberStr}</th>))}
                    </tr>
                    <tr>
                      <th>
                        <div style={{ marginBottom: 10, marginLeft: -7 }}>
                          <Button icon="plus" size="small"
                            style={{ marginRight: 2.5, marginTop: 5 }}
                            onClick={this.expandAllProjects} />
                          <Button icon="minus" size="small" style={{ marginTop: 5, marginRight: 5 }}
                            onClick={this.retractAllProjects} />
                        </div>
                      </th>
                      {months.map(m => m.days.map((d, index) => <th key={d.dayNumberStr}
                        className={d.weekend ? 'weekend timesheet-hours-header' : "timesheet-hours-header"}>{countDailyHours(moment(Date.UTC(m.year, m.monthNumber, d.dayNumber)).utc().dayOfYear(), index)}</th>))}
                    </tr>
                  </thead>
                  <tbody className="ant-table-tbody">
                    {items.map((r, i) => (this.filterByProjects(r) ? undefined :
                      <>
                        {newProject[i] && !(this.state.expandedProjects.has(r.projectId)) &&
                          <tr style={{ width: '100%', borderWidth: '2px' }}
                            data-tut={(this.state.expandedProjects.size > 0) ? "" : "reactour__fillTimesheet"}>
                            <td className='weekend'>
                              <h5
                                title={r.projectTitle}
                                style={{
                                  padding: '0px 5px',
                                  marginBottom: 0,
                                  width: 299,
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden"
                                }}>
                                <Icon
                                  type="caret-right"
                                  style={{ marginRight: 2 }}
                                  onClick={() => this.onSelectedProjectRow(r, i)}
                                />
                                {showFavorite &&
                                  <Favorite
                                    isFavorite={r.isFavorite}
                                    companyId={comapnyId}
                                    employeeId={employeeId}
                                    projectId={r.projectId}
                                    favoriteStatusChanged={
                                      (newValue) => {
                                        items.map((_r, _i) => {
                                          if (_r.projectId == r.projectId)
                                            _r.isFavorite = newValue
                                        })
                                        r.isFavorite = newValue
                                        this.setState({})
                                      }} />}
                                <Tooltip
                                  title={(!this.state.lockedExpandedProjects.has(r.projectId)) ? t("Unlocked") : t("Locked")}>
                                  <Icon
                                    type={(!this.state.lockedExpandedProjects.has(r.projectId)) ? "unlock" : "lock"}
                                    style={{ margin: 10, color: '#1890ff' }}
                                    onClick={() => this.onSelectLockExpanded(!this.state.lockedExpandedProjects.has(r.projectId), r.projectId)} />
                                </Tooltip>
                                {r.projectTitle}
                              </h5>

                            </td>


                            {months.map(m => m.days.map((d, index) => {
                              let currentDate = moment.utc(Date.UTC(m.year, m.monthNumber, d.dayNumber)).startOf("day")
                              let currentProjectHours = this.totalProjectHoursPerDay.get(r.projectId)
                              var hours = 0
                              if (currentProjectHours) {
                                hours = currentProjectHours.get(currentDate.dayOfYear()) ?? 0
                              }
                              return (
                                <td key={`${r.projectTitle}${currentDate.dayOfYear()}`}
                                  className='weekend'>
                                  <h5 style={{
                                    marginBottom: 0,
                                    width: 299,
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden"
                                  }}> {`${hours.toFixed(2).replace(/\.?0*$/, '')} ${t('hrs')}`}</h5>
                                </td>)
                            }))}

                            <td key={`${r.projectTitle}-Total`} className='weekend'>
                              <h5 style={{
                                marginBottom: 0,
                                width: 299,
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden"
                              }}>{`${(this.totalProjectHours.get(r.projectId) ?? 0).toFixed(2).replace(/\.?0*$/, '')} ${t('hrs')}`}</h5>
                            </td>
                          </tr>
                        }

                        {newProject[i] && (this.state.expandedProjects.has(r.projectId)) &&
                          <tr style={{ width: '100%', borderWidth: '2px' }}>
                            <td colSpan={9} className='weekend'>
                              <h5 style={{ padding: '0px 5px', marginBottom: 0 }}>
                                <Icon type="caret-down" style={{ marginRight: 2 }}
                                  onClick={() => this.onSelectedProjectRow(r, i)} />
                                {showFavorite &&
                                  <Favorite
                                    isFavorite={r.isFavorite}
                                    companyId={comapnyId}
                                    employeeId={employeeId}
                                    projectId={r.projectId}
                                    favoriteStatusChanged={
                                      (newValue) => {
                                        items.map((_r, _i) => {
                                          if (_r.projectId == r.projectId)
                                            _r.isFavorite = newValue
                                        })
                                        r.isFavorite = newValue
                                        this.setState({})
                                      }} />}
                                <Tooltip
                                  title={(!this.state.lockedExpandedProjects.has(r.projectId)) ? t("Unlocked") : t("Locked")}>
                                  <Icon
                                    type={(!this.state.lockedExpandedProjects.has(r.projectId)) ? "unlock" : "lock"}
                                    style={{ margin: 10, color: '#1890ff' }}
                                    onClick={() => this.onSelectLockExpanded(!this.state.lockedExpandedProjects.has(r.projectId), r.projectId)} />
                                </Tooltip>
                                {r.projectTitle}
                              </h5>
                            </td>
                          </tr>
                        }

                        {(this.state.expandedProjects.has(r.projectId) || this.state.lockedExpandedProjects.has(r.projectId)) &&
                          <tr key={`${r.rowKey}`} className="ant-table-row"
                            data-tut="reactour__fillTimesheet">
                            <td style={{ backgroundColor: 'white' }}>
                              {(self.state.rowEditing == r.rowKey) &&
                                <ProjectTaskEditor
                                  employeeId={this.props.employeeId}
                                  timesheetId={this.props.timesheetId}
                                  projectTaskId={r.rowKey} item={r.object}
                                  onClose={(projectTaskTitle: string, notes: string) => {
                                    if (projectTaskTitle)
                                      r.object.projectTaskTitle = projectTaskTitle
                                    if (notes)
                                      r.object.notes = notes
                                    this.setState({ rowEditing: undefined })
                                  }} />}
                              <span
                                className={'timesheet-item'}
                                style={{ padding: 5, cursor: 'pointer' }}
                                onClick={() => { if (!r.object['sticky'] || this.props.hasRoleAdminOrManager) this.toggleSelection(r.rowKey) }}
                              >
                                {self.props.rowsDataSource.render(r)}
                                {r.object.notes &&
                                  <Icon title={r.object.notes} type='info-circle' />}
                              </span>
                              {r.object['sticky'] &&
                                <div style={{ float: 'right' }}>
                                  <Tooltip title={t('Sticky')}>
                                    <Icon type="lock" />
                                  </Tooltip>
                                </div>
                              }
                              {!this.props.readonly && (!r.object['sticky'] || this.props.hasRoleAdminOrManager) && !r.disabled &&
                                < div style={{ float: 'right' }}>
                                  <Dropdown overlay={
                                    <Menu>
                                      {this.props.hasRoleAdminOrManager &&
                                        <Menu.Item onClick={(e) => {
                                          self.setState({ rowEditing: r.rowKey })
                                        }}>
                                          <Icon type='form' /> {t("Edit task")}
                                        </Menu.Item>}
                                      {(!r.object['sticky'] || this.props.hasRoleAdminOrManager) && !this.props.readonly &&
                                        <Menu.Item>
                                          <Popconfirm
                                            title={((this.state.changes.any(x => x.rowKey == r.rowKey)) ? t("The task have unsaved changes that will be lost in order to delete.") + " " : "") + t("Are you sure you want to delete this task?")}
                                            onConfirm={() => this.onRemoveRow(r.rowKey)}
                                            okText={t("Yes")}
                                            cancelText={t("No")}>
                                            <a>
                                              <Icon type='delete' /> {t("Delete")}
                                            </a>
                                          </Popconfirm>
                                        </Menu.Item>
                                      }
                                    </Menu>
                                  } trigger={['click']}>

                                    <span style={{ cursor: 'pointer', width: 64 }}>
                                      <EditableTooltip name="mytimesheet-inline-form">
                                        <Icon type='more' />
                                      </EditableTooltip>
                                    </span>
                                  </Dropdown>
                                </div>}
                            </td>
                            {months.map(m => m.days.map((d, index) => {
                              let today = moment().utc().endOf("day")
                              let currentProject = self.props.projectIdToSummary.get(r.projectId)
                              let currentDate = moment.utc(Date.UTC(m.year, m.monthNumber, d.dayNumber)).startOf("day")
                              let minProjectValidDate = moment.unix(currentProject?.fromDate ?? 0).utc().startOf("day")
                              let maxProjectValidDate = moment.unix(currentProject?.toDate ?? 253402300799).utc().endOf("day")
                              let colKey = currentDate.dayOfYear()
                              var message = self.getCurrentCellMessage(r.rowKey, colKey)
                              return <td key={`${r.rowKey}${currentDate.dayOfYear()}`}
                                className={d.weekend ? 'weekend' : undefined}>
                                <TimesheetInputView
                                  t={self.props.t}
                                  i18n={self.props.i18n}
                                  tReady={self.props.tReady}
                                  optionalTitle={(message) ? t('Edit comment') : t('Add a comment')}
                                  isEditableMessage={!(readonly || currentDate < minProjectValidDate || currentDate > maxProjectValidDate || r.disabled)}
                                  message={message}
                                  onAddMessage={() => this.onAddMessage(r.rowKey, colKey)}
                                  disabled={currentDate < minProjectValidDate || currentDate > maxProjectValidDate || (!this.props.isFutureAllowed && currentDate > today) || r.disabled}
                                  step={0.25}
                                  readOnly={readonly || currentDate < minProjectValidDate || currentDate > maxProjectValidDate || r.disabled}
                                  min={0}
                                  max={24}
                                  formatter={this.formatInput}
                                  parser={value => value ? value : ''}
                                  key={`${r.rowKey}${colKey}`}
                                  type='number'
                                  data-tut="reactour__fillTimesheet"
                                  value={this.getCurrentCellValue(r.rowKey, colKey)}
                                  onChange={(value) => this.handleChange(r.rowKey, colKey, value, message, r.projectTaskTitle, r.projectTitle, index)}
                                  onFocus={this.handleFocus}
                                  defaultValue={!this.state.pivotData[r.rowKey] ? 0 : (this.state.pivotData[r.rowKey][colKey] || 0)}
                                />

                                <Modal
                                  title={t('Describe your work')}
                                  visible={self.state.isAddingLogMessage && r.rowKey === self.state.currentLogMessageRow && colKey === self.state.currentLogMessageCol}
                                  onOk={() => {
                                    self.handleChange(r.rowKey, colKey, self.getCurrentCellValue(r.rowKey, colKey), self.state.currentLogMessage ?? "", r.projectTaskTitle, r.projectTitle, index)
                                    self.setState({ isAddingLogMessage: false, currentLogMessage: undefined })
                                  }}
                                  onCancel={() => {
                                    self.setState({ isAddingLogMessage: false, currentLogMessage: undefined })
                                  }}
                                  okText={t('Ok')}
                                  cancelText={t('Cancel')}>
                                  <Row justify="center">
                                    <Col>
                                      <span>{t('Comment')}</span>
                                      <TextArea
                                        onChange={({ target: { value } }) => self.setState({ currentLogMessage: value })}
                                        defaultValue={message}
                                        value={this.state.currentLogMessage !== undefined ? this.state.currentLogMessage : message}
                                      />
                                    </Col>
                                  </Row>
                                </Modal>
                              </td>
                            }))}
                            <td style={{ backgroundColor: "white" }}>
                              <b
                                style={{ margin: 10 }}>{formatDecimal(countHours(r.rowKey))} {t('hrs')}</b>
                            </td>
                          </tr>
                        }
                      </>))}
                  </tbody>
                </table>
                <div style={{ marginTop: 10 }}>
                  {!this.props.readonly && this.props.onAddProjectTask &&
                    <EditableTooltip name="timesheet-add-project">
                      <a data-tut="reactour__createtask" onClick={this.props.onAddProjectTask}>
                        <Button style={{ width: 32 }} icon="plus" /> {t("Add new project/task")}
                      </a>
                    </EditableTooltip>}

                  {!this.props.readonly && this.props.onDeleteEmptyTask && this.props.rowsDataSource.items.length > 0 &&
                    <Popconfirm
                      title={this.state.changes.length > 0 ? t("Are you sure you want to remove the lines without hours?") + " " + t("Save the changes made in these lines or they will be lost") : t("Are you sure you want to remove the lines without hours?")}
                      onConfirm={this.props.onDeleteEmptyTask}
                      okText={t("Yes")}
                      cancelText={t("No")}>
                      <a style={{ color: '#d9363e' }}>
                        <Button style={{
                          marginLeft: "10px",
                          width: "32px",
                          padding: "0px",
                          borderColor: '#d9363e'
                        }}>
                          <Icon type='delete' style={{ margin: "0px", color: '#d9363e' }} />
                        </Button> {t("Delete lines without hours")}
                      </a>
                    </Popconfirm>}
                  {!this.props.readonly && this.props.onDeleteMultiple && this.state.selectedItems.length > 0 &&
                    <Popconfirm
                      title={t("Are you sure you want to remove the selected lines?")}
                      onConfirm={() => {
                        if (this.props.onDeleteMultiple)
                          this.props.onDeleteMultiple(this.state.selectedItems)
                        this.setState({ selectedItems: [] })
                      }}
                      okText={t("Yes")}
                      cancelText={t("No")}>
                      <a style={{ color: '#d9363e' }}>
                        <Button style={{
                          marginLeft: "10px",
                          width: "32px",
                          padding: "0px",
                          backgroundColor: '#d9363e'
                        }}>
                          <Icon type='delete' style={{ margin: "0px", color: '#fff' }} />
                        </Button> {t("Delete selected lines")}
                      </a>
                    </Popconfirm>}
                </div>
              </div>
            </div>
          </div>
        </Card>
      </Spin>)
  }
}

export default withTranslation()(Timesheet)